<div class="spouse-details-container" [formGroup]="formGroup">

  <!-- Personal Information -->
  <div class="section-card">

    <div class="container-fluid">
      <div class="row g-3">

        <!-- Name -->
        <div class="col-md-6">
          <mat-label class="field-label">Name as in NRIC / Passport {{this.validator}}</mat-label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="spouseName" placeholder=" Enter Name as in NRIC">
            @if(this.formGroup.controls["spouseName"].invalid
            && (this.formGroup.controls["spouseName"].touched ||
            this.formGroup.controls["spouseName"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["spouseName"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- NRIC -->
        <div class="col-md-6">
          <mat-label class="field-label">NRIC No. {{this.validator}}</mat-label>

          <mat-form-field class="custom-form-field w-100">
            <input matInput formControlName="spousenric" placeholder=" Enter NRIC No.">
            @if(this.formGroup.controls["spousenric"].invalid
            && (this.formGroup.controls["spousenric"].touched ||
            this.formGroup.controls["spousenric"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["spousenric"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- DOB -->
        <div class="col-md-6">
          <mat-label class="field-label">Date Of Birth {{this.validator}}</mat-label>
          <mat-form-field class="w-100">
            <input matInput formControlName="spousedob" [matDatepicker]="picker" placeholder="DD/MM/YYYY">
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if(this.formGroup.controls["spousedob"].invalid
            && (this.formGroup.controls["spousedob"].touched ||
            this.formGroup.controls["spousedob"].dirty)
            ) {
            <mat-error>
              @if(this.formGroup.controls["spousedob"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>

      </div>
    </div>

  </div>


  <!-- Nationality -->
  <div class="section-card">

    <h3 class="section-header">
      <mat-icon>flag</mat-icon>
      Nationality {{this.validator}}
    </h3>

    <mat-radio-group formControlName="spouseNationality" class="d-flex flex-wrap gap-3 mb-3">
      <mat-radio-button value="Singapore Citizen">Singapore Citizen</mat-radio-button>
      <mat-radio-button value="Singapore Permanent Resident">Singapore Permanent Resident</mat-radio-button>
      <mat-radio-button value="others">Others</mat-radio-button>
    </mat-radio-group>
    @if(this.formGroup.controls["spouseNationality"].invalid
    && (this.formGroup.controls["spouseNationality"].touched ||
    this.formGroup.controls["spouseNationality"].dirty)
    ) {
    <mat-error>
      @if(this.formGroup.controls["spouseNationality"].errors?.["required"]) {
      <span>{{message}}</span>
      }
      @else {
      <span></span>
      }
    </mat-error>
    }
    <p class="note">
      For Singapore Permanent Resident & Others, please state:
    </p>

    <div class="row g-3">

      <div class="col-md-6">
        <mat-label class="field-label">Nationality {{this.validator}}</mat-label>
        <mat-form-field class="w-100">
          <mat-select formControlName="spouseothernationality" placeholder="Select Nationality">
            @for(nationality of this.nationalities; track nationality) {
            <mat-option value="{{nationality.value}}">{{nationality.name}}</mat-option>
            }
          </mat-select>
          @if(this.formGroup.controls["spouseothernationality"].invalid
          && (this.formGroup.controls["spouseothernationality"].touched ||
          this.formGroup.controls["spouseothernationality"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["spouseothernationality"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-label class="field-label">FIN or Passport No {{this.validator}}</mat-label>
        <mat-form-field class="w-100">
          <input matInput formControlName="spousefinorpassportno" placeholder=" Enter FIN or Passport No ">
          @if(this.formGroup.controls["spousefinorpassportno"].invalid
          && (this.formGroup.controls["spousefinorpassportno"].touched ||
          this.formGroup.controls["spousefinorpassportno"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["spousefinorpassportno"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

    </div>

  </div>


  <!-- Occupation -->
  <div class="section-card">

    <div class="row g-3">

      <div class="col-md-6">
        <mat-label class="field-label">Occupation {{this.validator}}</mat-label>

        <mat-form-field class="custom-form-field w-100">
          <input matInput formControlName="spouseoccupation" placeholder="Enter Occupation">
          @if(this.formGroup.controls["spouseoccupation"].invalid
          && (this.formGroup.controls["spouseoccupation"].touched ||
          this.formGroup.controls["spouseoccupation"].dirty)
          ) {
          <mat-error>
            @if(this.formGroup.controls["spouseoccupation"].errors?.["required"]) {
            <span>{{message}}</span>
            }
            @else {
            <span></span>
            }
          </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-label class="field-label">Name of Employer (Optional)</mat-label>

        <mat-form-field class="custom-form-field w-100">
          <input matInput formControlName="spouseemployer" placeholder="Enter Employer">
        </mat-form-field>
      </div>

    </div>

  </div>




</div>
@if(readonly() === false){
@if(isVisible() === true){
<div class="editor-actions">
  <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
  <button type="button" class="save-btn" (click)="saveSection()">
    <mat-icon>save</mat-icon>Save</button>
</div>
}@else{
<!-- Form Actions -->
<div class="form-actions">

  <button mat-raised-button class="save-btn" (click)="saveAndContinue()">

    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>

  </button>

</div>
}
}